import React from 'react';
import { ObservationWrapper } from 'apps/sigma2-ui/src/state/observation';
import { AppLayout } from 'apps/sigma2-ui/src/components/utils/AppLayout';
import { useSelectedDatabaseRevisionId } from 'apps/sigma2-ui/src/lib/hooks/useSelectedDatabaseRevisionId';
import { useSelectedDatabaseId } from 'apps/sigma2-ui/src/lib/hooks/useSelectedDatabaseId';
import { useSelectedOrganizationId } from 'apps/sigma2-ui/src/lib/hooks/useSelectedOrganizationId';
import { useMemo } from 'react';

/**
 * This component is used to force a re-render of the ObservationWrapper when the selected organization, database, or database revision changes.
 * @param children
 * @constructor
 */
export const ObservationWrapperWithKey = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const selectedOrganization = useSelectedOrganizationId();
  const selectedDatabase = useSelectedDatabaseId();
  const selectedDatabaseRevision = useSelectedDatabaseRevisionId();
  const key = useMemo(
    () =>
      `${selectedOrganization}-${selectedDatabase}-${selectedDatabaseRevision}`,
    [selectedOrganization, selectedDatabase, selectedDatabaseRevision],
  );
  return (
    <ObservationWrapper key={key}>
      <AppLayout>{children}</AppLayout>
    </ObservationWrapper>
  );
};
